import { DataTable } from 'primereact/datatable';
import { HeaderTable } from './HeaderTable';
import { useEffect, useRef, useState } from 'react';
import { GetDiscountsTable } from '../../../../services';
import { NotificationComponent } from '../../../../components/NotificationComponent';
import { DiscountType } from '../../../../interfaces';
import { FilterMatchMode } from 'primereact/api';
import { Column } from 'primereact/column';
import { DialogTableDiscount } from './DialogTableDiscount';
import { DiscountFormProvider, initialValue } from '../context/DiscountFormContext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import axios from 'axios';
import { DialogEditDiscount } from './DialogEditDiscount';

export const TableDiscounts = () => {
  const { toast, showSuccess, showSuccessEdit } = NotificationComponent();
  const [arrDiscounts, setArrDiscounts] = useState<DiscountType[]>([]);
  const [newValue, setNewValue] = useState();
  const [rowSelected, setRowSelected] = useState<any>(null!);
  const [openDialogEdit, setOpenDialogEdit] = useState(false);
  const [editValue, setEditValue] = useState<any>();
  const [enabled, setEnabled] = useState(true);
  const [syncing, setSyncing] = useState(false);
  let { loading, error, reload } = GetDiscountsTable({ setListDiscounts: setArrDiscounts, enabled });

  const filters = {
    description: {
      value: '',
      matchMode: FilterMatchMode.CONTAINS
    },
    enabled: {
      value: '',
      matchMode: FilterMatchMode.CONTAINS
    }
  };

  useEffect(() => {
    if (newValue) {
      console.log('NewValue =>', newValue);
      let newArr = arrDiscounts;
      newArr.push(newValue);
      setArrDiscounts(newArr);
    }
  }, [arrDiscounts, newValue]);

  useEffect(() => {
    reload();
  }, [enabled]);

  const syncDiscounts = () => {
    setSyncing(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BACKEND}/discounts/sync`,
        {},
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token_hhrr_latam')}`
          }
        }
      )
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sincronización exitosa',
          detail: 'Los descuentos fueron sincronizados desde SIS correctamente.',
          life: 4000
        });
        reload();
      })
      .catch(() => {
        toast.current?.show({
          severity: 'error',
          summary: 'Error al sincronizar',
          detail: 'No se pudo sincronizar con SIS. Intente nuevamente.',
          life: 4000
        });
      })
      .finally(() => {
        setSyncing(false);
      });
  };

  const actionEdit = (rowData: any) => {
    return (
      <Button
        icon='pi pi-pencil'
        className='p-button-rounded p-button-text p-button-warning '
        data-te-toggle='tooltip'
        title='Editar'
        onClick={() => {
          setRowSelected(rowData);
          setOpenDialogEdit(true);
        }}
      />
    );
  };

  const actionToast = (action: string) => {
    switch (action) {
      case 'success':
        showSuccess();
        break;
      case 'edit':
        showSuccessEdit();
        break;
      default:
        break;
    }
  };

  const permanentBody = (rowData: DiscountType) => {
    return rowData.permanent ? 'Sí' : 'No';
  };

  return (
    <DiscountFormProvider {...initialValue}>
      <>
        <Toast ref={toast} />
        <DataTable
          value={arrDiscounts}
          responsiveLayout='stack'
          breakpoint='960px'
          dataKey='id'
          emptyMessage={'No se encontraron datos'}
          rows={15}
          filters={filters}
          loading={loading}
          filterDisplay='row'
          paginator
          className='shadow-lg shadow-gray-500/30'
          header={
            <HeaderTable
              enabled={enabled}
              setEnabled={setEnabled}
              onSync={syncDiscounts}
              syncing={syncing}
            />
          }
        >
          <Column field='id' header={'Id'} sortable></Column>
          <Column
            field='description'
            filter
            showFilterMenu={false}
            filterPlaceholder={'Buscar por descuento'}
            header={'Tabla de descuentos'}
            sortable
          ></Column>
          <Column field='percentage' header={'Porcentaje'} sortable></Column>
          <Column header='Id de Sis' field='sis_discount_id'></Column>
          <Column field='discount_type' header={'Tipo de descuento'}></Column>
          <Column field='payment_type' header={'Tipo de pago'}></Column>
          <Column header={'Permanente'} body={permanentBody}></Column>
          <Column field='expiration_date' header={'Vencimiento'}></Column>
          <Column
            body={actionEdit}
            exportable={false}
            style={{ minWidth: '8rem' }}
          ></Column>
        </DataTable>
        <DialogTableDiscount actionToast={actionToast} reload={reload} />
        {openDialogEdit && (
          <DialogEditDiscount
            actionToast={actionToast}
            reload={reload}
            id={rowSelected.id}
            open={openDialogEdit}
            close={() => setOpenDialogEdit(false)}
          />
        )}
      </>
    </DiscountFormProvider>
  );
};
